import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { Row, Col } from 'antd';
import Titulo from 'components/Titulo';
import InputText from 'components/InputText';
import InputSelect from 'components/InputSelect';
import { cnpjMask, inscricaoMunicipalMask, inscricaoEstadualMask } from 'utils/masks';
import { fetchGetTodosAreaAtuacao, fetchGetTodosInstituicao } from 'store/fetchActions/fetchInputForm';
import { montarDadosInputSelect } from 'utils/funcaoPadrao';

export default function FormPessoaJuridica({
  control,
  onChange,
  errors,
  disabled,
  verificarRepeticao,
  disableDocumento,
}) {
  const dispatch = useDispatch();

  const unitaryTests = useSelector(state => state.app.unitaryTests);
  const inputSelectOptionsAreaAtuacao = useSelector(state => state.inputs.inputSelectOptionsAreaAtuacao);
  const inputSelectOptionsInstituicao = useSelector(state => state.inputs.inputSelectOptionsInstituicao);

  React.useEffect(() => {
    if (unitaryTests) return;
    dispatch(fetchGetTodosAreaAtuacao(inputSelectOptionsAreaAtuacao));
    dispatch(fetchGetTodosInstituicao(inputSelectOptionsInstituicao));
    // eslint-disable-next-line
  }, [dispatch, unitaryTests]);

  return (
    <>
      <Titulo textTitle={'Dados Profissionais'} />
      <Row justify="start">
        <Col xs={24} sm={16} md={8} lg={5} xl={5}>
          <InputText
            label="Cargo do Representante"
            name="cargoRepresentante"
            errors={errors}
            placeholder={'Cargo do Representante'}
            control={control}
            onChange={onChange}
            maxLength={150}
            disabled={disabled}
          />
        </Col>
        <Col xs={24} sm={16} md={8} lg={5} xl={5}>
          <InputText
            label="* Razão Social"
            name="razaoSocial"
            errors={errors}
            placeholder={'Razão Social'}
            control={control}
            onChange={onChange}
            maxLength={150}
            disabled={disabled}
          />
        </Col>
        <Col xs={24} sm={16} md={8} lg={3} xl={3}>
          <InputText
            label="* CNPJ"
            name="cnpj"
            errors={errors}
            placeholder={'CNPJ'}
            control={control}
            onChange={e => {
              if (e.target.value.length === 18) verificarRepeticao?.(e.target.value);
              onChange({
                target: {
                  name: 'cnpj',
                  value: cnpjMask(e.target.value),
                },
              });
            }}
            maxLength={18}
            disabled={disabled || disableDocumento}
          />
        </Col>
        <Col xs={24} sm={16} md={8} lg={5} xl={4}>
          <InputText
            label="Inscrição Estadual"
            name="inscricaoEstadual"
            errors={errors}
            placeholder={'Inscrição Estadual'}
            control={control}
            onChange={e =>
              onChange({
                target: {
                  name: 'inscricaoEstadual',
                  value: inscricaoEstadualMask(e.target.value),
                },
              })
            }
            maxLength={18}
            disabled={disabled}
          />
        </Col>
        <Col xs={24} sm={16} md={8} lg={5} xl={4}>
          <InputText
            label="Inscrição Municipal"
            name="inscricaoMunicipal"
            errors={errors}
            placeholder={'Inscrição Municipal'}
            control={control}
            onChange={e =>
              onChange({
                target: {
                  name: 'inscricaoMunicipal',
                  value: inscricaoMunicipalMask(e.target.value),
                },
              })
            }
            maxLength={18}
            disabled={disabled}
          />
        </Col>
        <Col xs={24} sm={16} md={8} lg={5} xl={4}>
          <InputSelect
            label="Tipo de Instituição"
            name="instituicaoId"
            errors={errors}
            placeholder={'Tipo de Instituição'}
            control={control}
            options={montarDadosInputSelect(inputSelectOptionsInstituicao, 'id', 'nomeInstituicao')}
            disabled={disabled}
          />
        </Col>
        <Col xs={24} sm={16} md={8} lg={5} xl={3}>
          <InputSelect
            label="Área de Atuação"
            name="areaAtuacaoId"
            errors={errors}
            placeholder={'Área de Atuação'}
            control={control}
            options={montarDadosInputSelect(inputSelectOptionsAreaAtuacao, 'id', 'atuacao')}
            disabled={disabled}
          />
        </Col>
      </Row>
    </>
  );
}

FormPessoaJuridica.propTypes = {
  control: PropTypes.object,
  onChange: PropTypes.func,
  errors: PropTypes.object,
  disabled: PropTypes.bool,
  verificarRepeticao: PropTypes.func,
};
